import { api_GET, api_POST } from "./_api.js";


const escalaOperadorColeta_api = {
    GetListEscala: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`EscalaOperadorColeta/GetList/Escala`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },

    GetListOperadoresColeta: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`EscalaOperadorColeta/GetList/OperadoresColeta`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        })
        return promise;
    },
    
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST('EscalaOperadorColeta', obj)
                .then(result => resolve(result))
                .catch(result => reject(result))
        })
        return promise;
    }    
}
export default escalaOperadorColeta_api;